<emma-portlet
    portletTitle="{{ selectionTitle ? title + ' (' + selectionTitle + ')' : title }}"
    [description]="description"
    [isError]="!!error"
    [showPadding]="false"
    [ngClass]="{
        'bigTitle': bigTitle
    }"
>
    <div *ngIf="selectOptions.length" class="emma-portlet-head-tools" role="group">
        <emma-select
            [items]="selectOptions"
            [(ngModel)]="selectCurrentValue"
            (ngModelChange)="onSelectChangeValue($event)"
            [labelKey]="selectLabelKey"
            [valueKey]="selectValueKey"
            [searchable]="selectSearchable"
            [isFullWidth]="false"
            [dropPanelRight]="true"
        ></emma-select>
    </div>
    <skudo-base-chart [identifier]="identifier" [loading]="loading"> </skudo-base-chart>
</emma-portlet>
